type ModuleStubPageProps = {
  title: string;
  blurb: string;
};

export function ModuleStubPage({ title, blurb }: ModuleStubPageProps) {
  return (
    <div className="flex flex-1 flex-col gap-4 p-8">
      <div>
        <p className="text-xs font-medium uppercase tracking-wider text-slate-500">Module placeholder</p>
        <h1 className="mt-1 text-2xl font-semibold text-slate-900 dark:text-white">{title}</h1>
        <p className="mt-2 max-w-2xl text-sm text-slate-600 dark:text-slate-400">{blurb}</p>
      </div>
      <div className="rounded-lg border border-dashed border-slate-300 bg-slate-100/50 p-6 text-sm text-slate-500 dark:border-slate-700 dark:bg-slate-900/50">
        This module is not ported yet. Track progress in{" "}
        <code className="text-slate-600 dark:text-slate-400">STEP3_ONE_PEEL.md</code>.
      </div>
    </div>
  );
}
